import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../utils/styledComponent';
import Badge from './atoms/Badge';
import theme from '../theme';

const StyledDiv = styledComponent('div', {
  border: theme.borders.card,
  borderRadius: theme.radii.inner,
  overflow: 'hidden',

  '& .collapsible-header': {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing.cellPadding,
    background: theme.colors.bgMuted,
    border: 'none',
    font: 'inherit',
    textAlign: 'left',
    '&:hover': {
      background: theme.colors.bgPage,
    },
  },

  '& .collapsible-title': {
    ...theme.typography.body,
    fontWeight: theme.fontWeights.semibold,
    color: theme.colors.text,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.gapMd,
  },

  '& .collapsible-icon': {
    transition: 'transform 0.2s',
    color: theme.colors.textMuted,
  },

  '& .collapsible-icon.expanded': {
    transform: 'rotate(180deg)',
  },

  '& .collapsible-body': {
    padding: theme.spacing.trafficBodyPadding,
  },

  '& .collapsible-loading': {
    textAlign: 'center',
    padding: theme.spacing.bodyPadding,
    color: theme.colors.textMuted,
  },
});

function CollapsibleSection({
  title,
  badge,
  expanded,
  onToggle,
  loading,
  loadingText,
  children,
}) {
  return (
    <StyledDiv>
      <button type="button" className="collapsible-header" onClick={onToggle}>
        <div className="collapsible-title">
          <span>{title}</span>
          {badge && <Badge variant="warning">{badge}</Badge>}
        </div>
        <span className={`collapsible-icon${expanded ? ' expanded' : ''}`}>
          &#9660;
        </span>
      </button>
      {expanded && (
        <div className="collapsible-body">
          {loading ? (
            <div className="collapsible-loading">
              {loadingText || 'Loading...'}
            </div>
          ) : (
            children
          )}
        </div>
      )}
    </StyledDiv>
  );
}

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.string,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loadingText: PropTypes.string,
  children: PropTypes.node,
};

CollapsibleSection.defaultProps = {
  badge: null,
  expanded: false,
  loading: false,
  loadingText: null,
  children: null,
};

export default CollapsibleSection;
